import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Users, Sword } from 'lucide-react';

const WelcomeModal = ({ onClose }) => {
  const navigate = useNavigate();

  const handleChoice = (path) => {
    localStorage.setItem('chag_welcomed', 'true');
    onClose();
    navigate(path);
  };

  return (
    <div className="fixed inset-0 bg-black/70 flex items-center justify-center z-50 p-4">
      <div className="bg-[#1E1E1E] border border-gray-700 rounded-lg shadow-2xl max-w-md w-full">
        <div className="text-center p-6 pb-4">
          <h2 className="text-xl font-bold text-gray-100 font-serif">
            Welcome to Chaggerheart
          </h2>
          <p className="text-sm text-gray-400 mt-2">
            What would you like to do first?
          </p>
        </div>

        <div className="px-6 pb-6 space-y-3">
          <button
            onClick={() => handleChoice('/create-campaign')}
            className="w-full flex items-center gap-4 p-4 bg-purple-900/20 border border-purple-700 rounded-lg hover:bg-purple-900/40 transition-colors text-left"
          >
            <Users className="w-8 h-8 text-purple-400 flex-shrink-0" />
            <div>
              <p className="text-sm font-semibold text-gray-100">I'm a GM</p>
              <p className="text-xs text-gray-400">Create a campaign and invite your players</p>
            </div>
          </button>

          <button
            onClick={() => handleChoice('/builder/new')}
            className="w-full flex items-center gap-4 p-4 bg-red-900/20 border border-red-700 rounded-lg hover:bg-red-900/40 transition-colors text-left"
          >
            <Sword className="w-8 h-8 text-red-400 flex-shrink-0" />
            <div>
              <p className="text-sm font-semibold text-gray-100">I'm a Player</p>
              <p className="text-xs text-gray-400">Create your first character</p>
            </div>
          </button>

          <button
            onClick={() => {
              localStorage.setItem('chag_welcomed', 'true');
              onClose();
            }}
            className="w-full text-center text-xs text-gray-500 hover:text-gray-300 transition-colors py-2"
          >
            I'll look around first
          </button>
        </div>
      </div>
    </div>
  );
};

export default WelcomeModal;
